import React from 'react';
import { SizeTileGroup, SizeTile } from 'anf-core-react';
import SizeGuideLink from './SizeGuideLink';

export default function PrimarySizeTiles({
  primarySizeArray,
  primarySizeTileHandler,
  primaryTileSize,
  primarySizeGroupHeading,
  activeProduct,
  tmntData,
  setSizeGuideOpen,
}) {
  const displaySelectedTileSize = primarySizeArray?.find(
    (primarySizeObj) => primarySizeObj.selected,
  );

  const { brand, hasSizeGuide, hasSizingFormat } = activeProduct;

  const primarySizeTiles = primarySizeArray
    && primarySizeArray.map((primarySizeObj) => {
      const {
        value, label, sizeText, available, selected, enableSelectableSoldOutSizeTiles,
      } = primarySizeObj;
      return (
        <SizeTile
          key={sizeText}
          isChecked={selected}
          onChange={primarySizeTileHandler}
          id={`radio_size_primary_${sizeText}`}
          name="size-primary"
          type="radio"
          value={value}
          size={primaryTileSize}
          label={label}
          isUnavailable={!available}
          hasDisabledStyle={enableSelectableSoldOutSizeTiles}
        />
      );
    });

  const renderTitle = () => {
    let measureFormat = '';

    if (hasSizingFormat) {
      measureFormat = ` (${tmntData?.jeansShortLocationHeader?.value})`;
    }

    return (
      <h3 className="product-sizes__name">
        {primarySizeGroupHeading}
        {measureFormat}
        :
        {' '}
        <span className="product-sizes__name__selected-size" data-testid="selected-size">
          {displaySelectedTileSize?.label}
        </span>
      </h3>
    );
  };

  return (
    <div className="product-sizes_primary-mfe" data-testid="primary-size-tiles">
      <div className="product-size-selection-header_wrapper-mfe">
        {renderTitle()}
        <SizeGuideLink
          brand={brand}
          hasSizeGuide={hasSizeGuide}
          sizeGuideLinkText={tmntData?.sizeGuideLinkText?.value}
          setSizeGuideOpen={setSizeGuideOpen}
        />
      </div>
      <SizeTileGroup
        legend={(
          <span className="screen-reader-text">
            {`${tmntData?.selectedSize?.value} ${primarySizeGroupHeading}`}
          </span>
        )}
      >
        {primarySizeTiles}
      </SizeTileGroup>
    </div>
  );
}
